import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// (16.10.2026) помилки в браузері відвідувача → client_errors → рядок у щоденному звіті адміну (api/_seo.js dailyReport).
// Ловимо і «тихі» помилки (необроблені проміси — як фотогалерея, що нічого не робила). Не більше 5 за відкриття сторінки, без повторів.
(() => {
  const seen = new Set(); let sent = 0;
  const NOISE = /ResizeObserver|^Script error\.?$|Failed to fetch|Load failed|NetworkError|AbortError|aborted|chrome-extension|moz-extension|safari-extension/i;
  const report = (message, stack) => {
    try {
      const m = String(message || '').slice(0, 300);
      if (!m || NOISE.test(m) || NOISE.test(String(stack || '')) || seen.has(m) || sent >= 5) return;
      seen.add(m); sent++;
      Promise.all([import('firebase/firestore'), import('./firebase')]).then(([{ collection, addDoc, serverTimestamp }, { db }]) => {
        addDoc(collection(db, 'client_errors'), { message: m, stack: String(stack || '').substring(0, 1500), ua: navigator.userAgent.substring(0, 200), url: window.location.href.substring(0, 300), ts: serverTimestamp() }).catch(() => {});
      }).catch(() => {});
    } catch (e) {}
  };
  // 25.10.2026: журнал помилок відвідувачів (client_errors) вимкнено разом із закриттям сайту.
  void report;
})();

const SITE_PASSWORD = '696969';

function Gate() {
  const [input, setInput] = useState('');
  const [unlocked, setUnlocked] = useState(localStorage.getItem('sm_unlocked') === '1');
  const [error, setError] = useState('');

  const tryUnlock = () => {
    if (input === SITE_PASSWORD) {
      localStorage.setItem('sm_unlocked', '1');
      setUnlocked(true);
    } else {
      setError('Невірний пароль');
    }
  };

  if (unlocked) return <App />;

  return (
    <div style={{ minHeight: '100vh', background: '#0d0d0d', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', padding: '20px' }}>
      <div style={{ color: '#FFD700', fontSize: '20px', fontWeight: 'bold', marginBottom: '20px' }}>ScrapMarket</div>
      <input
        type="password"
        value={input}
        onChange={e => setInput(e.target.value)}
        onKeyDown={e => e.key === 'Enter' && tryUnlock()}
        placeholder="Пароль"
        style={{ padding: '12px', borderRadius: '8px', border: '2px solid #FFD700', backgroundColor: '#1a1a1a', color: '#fff', fontSize: '16px', width: '200px', textAlign: 'center', marginBottom: '10px' }}
        autoFocus
      />
      <button
        onClick={tryUnlock}
        style={{ padding: '12px 24px', backgroundColor: '#FFD700', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}
      >Увійти</button>
      {error && <div style={{ color: '#f44336', fontSize: '13px', marginTop: '10px' }}>{error}</div>}
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Gate />
  {/* 25.10.2026 САЙТ ЗАКРИТИЙ паролем. Відкрити — замінити <Gate /> на <App /> (але спершу: власник у політиці конфіденційності). */}</React.StrictMode>
);

reportWebVitals();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
  // Прибрано автоматичне перезавантаження — воно стирало результати пошуку користувача.
  // Нова версія сайту застосується сама, при наступному природному відкритті сторінки.
}